// extracted by mini-css-extract-plugin
export default {"user-panel":"user_user-panel__jl+vu","pass-reset-form":"user_pass-reset-form__pnomz"};